var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [_c('resume-personal-information', {
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-name', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-education', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-work-experience', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-hash-tags', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-languages', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-office-skills', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-certifications', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  }), _c('resume-cover-letter', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.resume,
      "mode": "view"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }